<template>
  <el-container style="height: 100%; border: 1px solid #eee">

    <el-aside width="260px">

      <el-menu
        :default-openeds="['1']"
        theme="dark"
      >
        <div class="brand">Samsung Promotool</div>
        <el-menu-item-group>
          <el-menu-item index="1-1">
            <router-link :to="{ path: '/'}"><i class="el-icon-menu"></i> Dashboard</router-link>
          </el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="1-1"><a @click="unpublishedPromo"><i class="el-icon-menu"></i> Unpublished Promo</a></el-menu-item>
        </el-menu-item-group>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header style="text-align: right; font-size: 12px; height: auto">
        <el-button
          style="float: left"
          @click="publishData('staging')"
        >Publish Staging</el-button>
        <el-button
          style="float: left"
          @click="publishData('live')"
          type="danger"
        >Publish Live</el-button>

        <div style="padding-top: 8px">
          <el-dropdown>
            <span class="lang">{{$lang}}</span>
            <i
              class="el-icon-arrow-down"
              style="margin-right: 15px"
            ></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="update$lang('nl')">NL</el-dropdown-item>
              <el-dropdown-item @click.native="update$lang('be')">BE</el-dropdown-item>
              <el-dropdown-item @click.native="update$lang('be_fr')">BE_FR</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <span>{{email}}</span>
          <span @click="logout">Logout</span>
        </div>
      </el-header>

      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import axios from "axios";
import { firebase, db, promotionsCollection } from "../../firebase-config.js";

export default {
  data: function() {
    return {
      email: "",
      live: "",
      promotionsData: [],
      unpublishedPromoId: ""
    };
  },
  computed: {
    $lang: function() {
      return this.$store.state.$lang;
    }
  },
  created() {
    const user = firebase.auth().currentUser;
    let name, email, photoUrl, emailVerified;

    if (user != null) {
      name = user.displayName;
      email = user.email;
      photoUrl = user.photoURL;
      emailVerified = user.emailVerified;
    }

    this.email = email;
  },
  methods: {
    update$lang: function(newLang) {
      console.log("update");
      localStorage.setItem("lang", newLang);
      return this.$store.commit("update$lang", newLang);
    },
    unpublishedPromo() {
      this.$prompt("Enter Promo ID (ex: 4DCY3KSUXLLU3)", "Unpublished promo", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        inputPattern: /^[a-zA-Z0-9]{10,14}$/,
        inputErrorMessage: "Promo ID is not valid"
      })
        .then(({ value }) => {
          this.$router.push({ path: `/update/${value}` });
          this.$message({
            type: "success",
            message: "Promo succesfully loaded."
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Input canceled"
          });
        });
    },
    logout() {
      this.$confirm("Are you sure you want to logout?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(() => {
          this.$router.push({ path: "logout" });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Logout is canceld."
          });
        });
    },
    publishData(type) {
      this.promotionsData = [];
      promotionsCollection.get().then(querySnapshot => {
        this.loading = false;
        querySnapshot.forEach(doc => {
          console.log(doc.data());
          console.log(doc.data().lang);
          if (doc.data().lang === this.$lang) {
            let data = {
              promotionId: doc.data().promotionId,
              models: doc.data().models,
              codes: doc.data().codes,
              active: doc.data().active,
              squareHeader: doc.data().squareHeader || false,
              squareSecondary: doc.data().squareSecondary || false,
              noPurchaseOptions: doc.data().noPurchaseOptions || false
            };
            this.promotionsData.push(data);
          }
        });

        console.log(this.promotionsData);

        if (type === "live") {
          this.$confirm("Are you sure you want to publish?", "Warning", {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning"
          })
            .then(() => {
              console.log("live publish");
              axios
                .post(
                  `./publish/${this.$lang}/publish-live.php`,
                  this.promotionsData
                )
                .then(data => {
                  console.log("publish live");
                  const live = false;

                  this.$message({
                    type: "success",
                    message: "Het publiceren is gelukt."
                  });
                })
                .catch(error => {
                  console.log(error);

                  this.$message({
                    type: "error",
                    message: "Het publiceren is mislukt."
                  });
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Het publiceren is geannuleerd."
              });
            });
        } else if (type === "staging") {
          this.$confirm(
            "Weet je zeker dat je wilt dit wilt publiceren naar staging?",
            "Waarschuwing",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning"
            }
          )
            .then(() => {
              console.log("staging publish");
              axios
                .post(
                  `./publish/${this.$lang}/publish-staging.php`,
                  this.promotionsData
                )
                .then(data => {
                  console.log("publish staging");
                  const live = true;

                  this.$message({
                    type: "success",
                    message: "Het publiceren is gelukt."
                  });
                })
                .catch(error => {
                  console.log(error);

                  this.$message({
                    type: "error",
                    message: "Het publiceren is mislukt."
                  });
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Het publiceren is geannuleerd."
              });
            });
        }
      });
    }
  }
};
</script>
<style>
.lang {
  font-weight: bold;
  text-transform: uppercase;
  margin-right: 2px;
}
</style>


// WEBPACK FOOTER //
// Default.vue?3651b4c2